import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/lib/i18n";

import Landing from "@/pages/Landing";
import IubendaLoader from "@/components/IubendaLoader";
import FreeHub from "@/pages/FreeHub";
import FreeTest from "@/pages/FreeTest";
import PremiumPractice from "@/pages/PremiumPractice";
import Simulation from "@/pages/Simulation";
import SimulationResult from "@/pages/SimulationResult";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import TestList from "@/pages/TestList";
import TestPlayer from "@/pages/TestPlayer";
import TestResult from "@/pages/TestResult";
import Guides from "@/pages/Guides";
import GuideReader from "@/pages/GuideReader";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminPreview from "@/pages/AdminPreview";
import { Privacy, Terms, Cookies } from "@/pages/Legal";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-slate-500">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <IubendaLoader />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/free" element={<FreeHub />} />
            <Route path="/free/:category" element={<FreeTest />} />
            <Route path="/premium/:category" element={<Protected><PremiumPractice /></Protected>} />
            <Route path="/simulazione" element={<Simulation />} />
            <Route path="/simulazione/:attemptId/risultati" element={<SimulationResult />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/tests" element={<TestList />} />
            <Route path="/tests/:testId/play" element={<Protected><TestPlayer /></Protected>} />
            <Route path="/tests/result" element={<Protected><TestResult /></Protected>} />
            <Route path="/guides" element={<Guides />} />
            <Route path="/guides/:guideId" element={<Protected><GuideReader /></Protected>} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/admin/anteprima" element={<Protected><AdminPreview /></Protected>} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
